/* TODO: update according to reality */

import translate from "src/functions/translate";

function optionsStyle(lang: string) {
  return [
    { title: translate(`any`, lang), value: `any` },
    { title: translate(`acro`, lang), value: `acro` },
    { title: translate(`anusara`, lang), value: `anusara` },
    { title: translate(`ashtanga`, lang), value: `ashtanga` },
    { title: translate(`baby`, lang), value: `baby` },
    { title: translate(`bikram`, lang), value: `bikram` },
    { title: translate(`DNS method`, lang), value: `DNS_method` },
    { title: translate(`for kids`, lang), value: `for_kids` },
    { title: translate(`hatha`, lang), value: `hatha` },
    { title: translate(`chakra`, lang), value: `chakra` },
    { title: translate(`iyengar`, lang), value: `iyengar` },
    { title: translate(`jivamukti`, lang), value: `jivamukti` },
    { title: translate(`kundalini`, lang), value: `kundalini` },
    { title: translate(`laughter yoga`, lang), value: `laughter_yoga` },
    { title: translate(`massage`, lang), value: `massage` },
    { title: translate(`meditation`, lang), value: `meditation` },
    { title: translate(`more styles`, lang), value: `more_styles` },
    { title: translate(`mysore`, lang), value: `mysore` },
    { title: translate(`office yoga`, lang), value: `office_yoga` },
    { title: translate(`postnatal`, lang), value: `postnatal` },
    { title: translate(`power`, lang), value: `power` },
    { title: translate(`prana flow`, lang), value: `prana_flow` },
    { title: translate(`prenatal`, lang), value: `prenatal` },
    { title: translate(`restorative`, lang), value: `restorative` },
    { title: translate(`rolf`, lang), value: `rolf` },
    { title: translate(`tantra`, lang), value: `tantra` },
    { title: translate(`teenage`, lang), value: `teenage` },
    { title: translate(`therapeutic`, lang), value: `therapeutic` },
    { title: translate(`traditional`, lang), value: `traditional` },
    { title: translate(`vinyasa`, lang), value: `vinyasa` },
    { title: translate(`wheel`, lang), value: `wheel` },
    { title: translate(`yin`, lang), value: `yin` },
    { title: translate(`yoga`, lang), value: `yoga` },
  ];
}

export default optionsStyle;
